import { useEffect, useState } from 'react'
import { type QueryClient } from '@tanstack/react-query'
import {
  createRootRouteWithContext,
  Outlet,
  useRouterState,
} from '@tanstack/react-router'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Toaster } from '@/components/ui/sonner'
import { SplashScreen } from '@/components/splash-screen'
import { GeneralError } from '@/features/errors/general-error'
import { NotFoundError } from '@/features/errors/not-found-error'

const MIN_SPLASH_MS = 800
const FADE_OUT_MS = 300
// Ly/nnIvnnIvov5nkuKrmlofku7bnmoQgZ2l0IOaXtumXtOe6v++8jOacieaDiuWWnA==
export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
}>()({
  component: () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const status = useRouterState({ select: (s) => s.status })
    const routerReady = status !== 'pending'

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [minTimePassed, setMinTimePassed] = useState(false)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [animDone, setAnimDone] = useState(false)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [phase, setPhase] = useState<'show' | 'fade' | 'done'>('show')

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      const t = setTimeout(() => setMinTimePassed(true), MIN_SPLASH_MS)
      return () => clearTimeout(t)
    }, [])

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (phase === 'show' && routerReady && minTimePassed && animDone) {
        setPhase('fade')
        const t = setTimeout(() => setPhase('done'), FADE_OUT_MS)
        return () => clearTimeout(t)
      }
    }, [phase, routerReady, minTimePassed, animDone])

    return (
      <>
        {phase !== 'done' && (
          <SplashScreen
            fadingOut={phase === 'fade'}
            onComplete={() => setAnimDone(true)}
          />
        )}
        <Outlet />
        <Toaster duration={5000} />
        {import.meta.env.MODE === 'development' && (
          <>
            <ReactQueryDevtools buttonPosition='bottom-left' />
            {/* <TanStackRouterDevtools position='bottom-right' /> */}
          </>
        )}
      </>
    )
  },
  notFoundComponent: NotFoundError,
  errorComponent: GeneralError,
})
